import type { CSSProperties } from 'react';

// Sprite sheet definitions and item→icon mappings

export interface SpriteSheet {
  url: string;
  cols: number;
  rows: number;
}

export interface SpriteFrame {
  sheet: 'weapons' | 'armor' | 'resources';
  col: number;
  row: number;
}

export const SPRITE_SHEETS: Record<string, SpriteSheet> = {
  weapons: {
    url: '/assets/Neu/icons_weapons.png',
    cols: 6,
    rows: 4,
  },
  armor: {
    url: '/assets/Neu/icons_armor.png',
    cols: 6,
    rows: 3,
  },
  resources: {
    url: '/assets/Neu/icons_resources.png',
    cols: 5,
    rows: 3,
  },
};

// Maps item ID → sprite sheet position
// Weapons sheet (6×4): row0=swords, row1=axes/spears, row2=daggers/staves, row3=special
// Armor sheet (6×3):   row0=helmets, row1=chest/rings, row2=boots/accessories
// Resources sheet (5×3): row0=cells/chips/scrap, row1=crystals/cores, row2=tools
export const ITEM_SPRITES: Record<string, SpriteFrame> = {
  // Weapons
  nano_blade:         { sheet: 'weapons', col: 0, row: 0 },
  pulse_saber:        { sheet: 'weapons', col: 2, row: 0 },
  hyper_cannon:       { sheet: 'weapons', col: 2, row: 1 },

  // Helmets (row 0 of armor sheet)
  salvage_helm:       { sheet: 'armor', col: 0, row: 0 },
  combat_visor:       { sheet: 'armor', col: 1, row: 0 },

  // Chest armor (row 1)
  circuit_vest:       { sheet: 'armor', col: 0, row: 1 },
  nano_plate:         { sheet: 'armor', col: 1, row: 1 },

  // Accessories (row 1, right side)
  signal_ring:        { sheet: 'armor', col: 4, row: 1 },
  overdrive_core:     { sheet: 'armor', col: 5, row: 1 },

  // Resources
  energy_cell:        { sheet: 'resources', col: 0, row: 0 },
  data_track:         { sheet: 'resources', col: 1, row: 0 },
  nano_chip:          { sheet: 'resources', col: 2, row: 0 },
  scrap:              { sheet: 'resources', col: 3, row: 0 },
  hyper_processor_5:  { sheet: 'resources', col: 4, row: 0 },
};

export function getSpriteStyle(
  frame: SpriteFrame,
  sizeRem: number = 3,
): CSSProperties {
  const sheet = SPRITE_SHEETS[frame.sheet];
  return {
    backgroundImage: `url('${sheet.url}')`,
    backgroundSize: `${sheet.cols * 100}% ${sheet.rows * 100}%`,
    backgroundPosition: `${(frame.col / Math.max(sheet.cols - 1, 1)) * 100}% ${(frame.row / Math.max(sheet.rows - 1, 1)) * 100}%`,
    backgroundRepeat: 'no-repeat',
    width: `${sizeRem}rem`,
    height: `${sizeRem}rem`,
    imageRendering: 'auto',
  };
}
